
export const GET_BUILDING_TRANSACTION_LIST = '/building/get_building_transaction_list';
export const RPT_BUILDING_GENERATE = '/api/v1/rpt/administrator/buildings/building_applications/{building_application_id}/transactions/{transaction_id}/preview_soa'
export const SHOW_DATA = 'building/show_data';
